module.exports = {
  en: {
    'Forum IDC': 'Forum IDC',
    message: {
      hello: 'hello world',
      greeting: 'good morning',
    }
  },
  fr: {
    'Hello World!': 'Bonjour!',
    message: {
      hello: 'bonjour',
      greeting: 'hwahwa'
    }
  },
  ja: {
    'Hello World!': 'こんにちは、世界',
    message: {
      hello: 'こんにちは、世界',
      greeting: 'おはようございます'
    }
  }
}
